import React from 'react';

import Container from "react-bootstrap/Container";


const Footer = () => (
  <footer>
    <Container>
          <p>OnlineCasino © 2022.</p>
          {/* <div className="d-flex justify-content-around">
            <a href="#">Home</a>
            <a href="#">Terms</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Disclaimer</a>
          </div> */}
          <p className = "disclaimer">
            OnlineCasino.com has no intention for the information presented
            on this website to be used for illegal, unlawful or otherwise
            prohibited purposes. It is the sole responsibility of the visitor to
            confirm that they meet all necessary legal requirements before
            signing up for a real money account at a casino and placing any real
            money bets. By using this website, the visitor agrees to the terms
            and conditions set forth by OnlineCasino.com. In many
            jurisdictions, real money online gambling is restricted or illegal.
            Users are advised to do all necessary legal due diligence concerning
            the legality of online gambling in their area of residence before
            visiting an online casino and creating an account.
            OnlineCasino.com is an independent entity, not connected to any
            online gambling operator and the free content provided on our site
            is for informational purposes only. By clicking on any third
            party/operator links on our website, you will be redirected to
            another website. Non-operator links are provided for educational
            purposes only.
          </p>
        </Container>
  </footer>
)

export default Footer;